import { updateIframeHeight } from '../updateIframeHeight';
export const embedIframe = () => updateIframeHeight('.js-embed__iframe');
